<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Perfect-Center"><span class="italics-center-16"><br/></span></p>
<p class="Perfect-Center"><span class="italics-center-16"><br/></span></p>
<p class="Perfect-Center"><span class="italics-center-16">Dedic<a id="uCTCbdXjznSYHGG5P8sDolD"></a>ated to Nancy</span></p>
<p class="FIRSTPARAGRAPH"><span class="italics-center-16"> </span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?0cd46080